
export const ReturnOfPremium = () => {
    return (
        <>
         <div className="container-fluid">
            <div className="row pb-5" >

                <div className="col-lg-12 text-center pb-5">
                    <h2 className=" mt-4 fw-bold">Return of Premium </h2>
                    <div className="col-8 col-lg-3 mx-auto zoom-in-out-box2 ">
                        <hr />
                    </div>
                </div>

                <div className="col-12  px-lg-5">
                    <div className="p-lg-2 p-4  " style={{textAlign: 'justify', }}>
                        <p>
                            Underwriter receives the premium as a consideration under the contract of insurance for running the risk of indemnifying the assured, if he does not run the risk he ought to return the premium. Failure of consideration is where no risk attaches at all. In case of Cargo policy covering the transit of goods and insured goods not despatched at all or altogether the different voyage substituted for that contemplated.
                        </p>
                    </div>
                </div>

                <div className="col-12 px-lg-5 mt-2">

                    <div className=" food_for_health">
                        <div className="row  ps-lg-5 p-4 p-lg-0">
                            <div className="col-12 col-lg-8 pt-lg-5" style={{textAlign: 'justify', }}>
                                <p><b> Food for Thought:  </b></p>

                                <p><i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    Are there any agreed situations when premiums are returnable?   </p>

                                <p> <i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    Does Return of Premium applicable to Honour Policies?</p>

                                <p><i class="fa-solid fa-circle-question text-danger pe-3"></i>
                                    Will there be any return of Premium under Unvalued policies when the subject matter is insured in excess of its insurable value?    </p>

                            </div>
                            <div className="col-12 col-lg-4 d-flex align-items-center justify-content-center">
                                <img src="Static/Assets/Img/questionary.png" className="questionery_img mx-auto" alt="" srcset="" />

                            </div>
                        </div>


                    </div>
                </div>
            </div>
            </div>
            {/* <Footer /> */}
            {/* </div>
            </div> */}
        </>
    )
}
